var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conBG"},[_c('ul',{staticClass:"menuList"},[_vm._l((_vm.list),function(item,index){return _c('li',{key:item.id,class:{'active':_vm.navIndex==index},on:{"click":function($event){_vm.navIndex=index; _vm.to(item)}}},[_vm._v(" "+_vm._s(item.name))])}),_c('div',{staticStyle:{"clear":"both"}})],2),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }